import React from 'react';

import PropTypes from 'prop-types';

import { Radio } from 'antd';

import './style.scss';

const CustomRadioButton = ({ children, value, className, ...rest }) => {
  const classN = `custom-radio-btn ${className}`;
  return (
    <Radio className={classN} value={value} {...rest}>
      {children}
    </Radio>
  );
};

export default CustomRadioButton;

CustomRadioButton.propTypes = {
  children: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string
};
